// removed by extract-text-webpack-plugin
module.exports = {"container":"_5-AoRiVHJtvuLWAjDINxK","option":"_1nUQ7XE8B0RmzFOKFvQ-fO","icon":"_2AWaKTkedCCMynt73z72rI","title":"_2ZI3Hz6mIvBh0NnEaD0cg0"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/AdvancedSettings/Advance/styles.css
// module id = 2765
// module chunks = 0